export default "__VITE_ASSET__BTa_rd$T__"